import Manager from './valueDriverManager';

export default Manager;
